/** Tenant branding for the patient loyalty app. */
export const PATIENT_PORTAL_TAGLINE = 'Your health. Your rewards.';

/** Default login / marketing mark (transparent PNG). */
export const PATIENT_PORTAL_LOGIN_LOGO_PATH = '/truecare/logo.png';

export type PatientPortalBranding = {
  hospitalId: string | null;
  hospitalName: string | null;
  logoUrl: string;
  primaryColor: string | null;
  loyaltyEnabled: boolean;
};

export const DEFAULT_PATIENT_PORTAL_BRANDING: PatientPortalBranding = {
  hospitalId: null,
  hospitalName: null,
  logoUrl: PATIENT_PORTAL_LOGIN_LOGO_PATH,
  primaryColor: null,
  loyaltyEnabled: true,
};

export function mergePortalBranding(
  api?: Partial<{
    hospitalId?: string | null;
    hospitalName?: string | null;
    logoUrl?: string | null;
    primaryColor?: string | null;
    loyaltyEnabled?: boolean;
  }> | null
): PatientPortalBranding {
  if (!api) return { ...DEFAULT_PATIENT_PORTAL_BRANDING };
  return {
    hospitalId: api.hospitalId?.trim() || null,
    hospitalName: api.hospitalName?.trim() || null,
    logoUrl: api.logoUrl?.trim() || PATIENT_PORTAL_LOGIN_LOGO_PATH,
    primaryColor: api.primaryColor?.trim() || null,
    loyaltyEnabled: api.loyaltyEnabled !== false,
  };
}

/** Care journey line on home hero — hospital name when known. */
export function careJourneySubtitle(hospitalName: string | null, uhid?: string | null): string {
  const facility = hospitalName ? `at ${hospitalName}` : 'with your care team';
  if (uhid) return `Your care journey ${facility} · UHID ${uhid}`;
  return `Your care journey ${facility}`;
}
